export const getCommonReportFields = (
  pa,
  requestedReports,
  idx,
  isBaseline,
  hasOhtFilter,
  hasDeviceClassesFilter
) => {
  const higherLevelText = !isBaseline && pa.IncludeHigherLevels ? 'Yes' : 'No';
  const higherProgramYearText = !isBaseline && pa.IncludeHigherProgramYears ? 'Yes' : 'No';
  const includeExactMatchedDeviceClassesText =
    !isBaseline && pa.IncludeExactMatchedDeviceClasses ? 'Yes' : 'No';
  const includeExactMatchedOhtsText = !isBaseline && pa.IncludeExactMatchedOhts ? 'Yes' : 'No';

  const dataPoint = {};

  dataPoint[`Table`] = `${idx + 1}`;
  dataPoint[`Program Year`] = isBaseline ? `1` : `${pa.Year}`;
  if (!isBaseline) dataPoint[`Higher Years Included`] = `${higherProgramYearText}`;
  dataPoint[`Practice Group Level`] = `${pa.DefaultLevel}`;
  if (!isBaseline) dataPoint[`Higher Levels Included`] = `${higherLevelText}`;

  if (hasDeviceClassesFilter) {
    dataPoint['Device Classes'] =
      requestedReports[idx].deviceClasses.length > 0
        ? requestedReports[idx].deviceClasses.map(x => x.displayName).join(',')
        : '';
    dataPoint['Matches Class selection exactly'] = includeExactMatchedDeviceClassesText;
  }

  if (hasOhtFilter) {
    dataPoint[`OHTs`] =
      requestedReports[idx].ohts.length > 0
        ? `${requestedReports[idx].ohts.map(x => x.displayName.replace('OHT', '')).join(',')}`
        : '';
    dataPoint['Matches OHT selection exactly'] = includeExactMatchedOhtsText;
  }

  dataPoint[`Practice Area`] = `${pa.Name + ', ' + pa.Acronym}`;

  return dataPoint;
};

export const getExistingFilterFlags = (isBaseline, requestedReports) => {
  const hasOhtFilter =
    !isBaseline &&
    requestedReports &&
    requestedReports.some(report => report.ohts && report.ohts.length > 0);

  const hasDeviceClassesFilter =
    !isBaseline &&
    requestedReports &&
    requestedReports.some(report => report.deviceClasses && report.deviceClasses.length > 0);

  return { hasOhtFilter, hasDeviceClassesFilter };
};
